"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./index.module.css");
var classnames_1 = require("classnames");
var luxon_1 = require("luxon");
var Day_1 = require("../Day");
var IconButton_1 = require("../IconButton");
var md_1 = require("react-icons/md");
var NativeSelect_1 = require("../NativeSelect");
exports.captions = ['일', '월', '화', '수', '목', '금', '토'];
exports.today = new Date();
var startYear = 2050;
exports.currentYear = exports.today.getFullYear();
var endYear = 1950;
exports.startMonth = exports.today.getMonth() + 1;
exports.years = new Array(startYear - endYear + 1)
    .fill(0)
    .map(function (_, key) {
    var year = startYear - key;
    return { id: year.toString(), name: year + "\uB144" };
})
    .reverse();
exports.months = new Array(12).fill(0).map(function (_, key) {
    var month = key + 1;
    return { id: month.toString(), name: month + "\uC6D4" };
});
function isInvalidDate(date) {
    return isNaN(date.getTime());
}
exports.isInvalidDate = isInvalidDate;
function getValidDate(date) {
    return isInvalidDate(date) ? new Date() : date;
}
exports.getValidDate = getValidDate;
function getValidDateTime(value) {
    var date;
    if (value === undefined || value === null) {
        date = new Date();
    }
    else if (typeof value === 'string' || typeof value === 'number') {
        date = getValidDate(new Date(value));
    }
    else {
        date = getValidDate(value);
    }
    return luxon_1.DateTime.fromJSDate(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
}
exports.getValidDateTime = getValidDateTime;
function getVariationDate(year, month, value) {
    var nextMonth = month + value;
    var nextYear = year;
    if (nextMonth < 1) {
        nextMonth = 12;
        nextYear--;
    }
    else if (nextMonth > 12) {
        nextMonth = 1;
        nextYear++;
    }
    return {
        year: nextYear,
        month: nextMonth,
    };
}
exports.getVariationDate = getVariationDate;
var todayDateTime = luxon_1.DateTime.local().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            year: exports.currentYear,
            month: exports.startMonth,
        };
        _this.updateDatePicker = function (props) {
            if (props === void 0) { props = _this.props; }
            var allowChangeCalendar = props.allowChangeCalendar, value = props.value;
            if (allowChangeCalendar) {
                var dateTime = getValidDateTime(value);
                _this.setState({ year: dateTime.year, month: dateTime.month });
            }
        };
        return _this;
    }
    DatePicker.prototype.componentDidMount = function () {
        this.updateDatePicker();
    };
    DatePicker.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.value !== nextProps.value) {
            this.updateDatePicker(nextProps);
        }
    };
    DatePicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, style = _a.style, className = _a.className, value = _a.value, onChange = _a.onChange;
        var _b = this.state, year = _b.year, month = _b.month;
        var dateTime = getValidDateTime(value);
        var hasSelected = value !== undefined && value !== null && value !== '';
        var startDateTime = dateTime.set({ year: year, month: month });
        var days = [];
        var firstDateTime = startDateTime.set({ day: 1 });
        var weekday = firstDateTime.weekday, daysInMonth = firstDateTime.daysInMonth;
        var startDays = weekday === 7 ? 0 : weekday;
        var _loop_1 = function (i) {
            var currentDateTime = firstDateTime.plus({ day: i });
            var isDayInMonth = firstDateTime.year === currentDateTime.year &&
                firstDateTime.month === currentDateTime.month;
            var isToday = todayDateTime.equals(currentDateTime);
            var isSelected = hasSelected && currentDateTime.equals(dateTime);
            var isWeekend = currentDateTime.weekday === 7 || currentDateTime.weekday === 6;
            days.push(React.createElement(Day_1.default, { key: i, dateTime: currentDateTime, isToday: isToday, isWeekend: isWeekend, isSelected: isSelected, isDayInMonth: isDayInMonth, onClick: function () {
                    if (onChange) {
                        _this.setState({ year: currentDateTime.year, month: currentDateTime.month }, function () {
                            onChange(currentDateTime.toJSDate());
                        });
                    }
                } }));
        };
        for (var i = -startDays; i < daysInMonth; i++) {
            _loop_1(i);
        }
        return (React.createElement("div", { style: style, className: classnames_1.default(styles.datePicker, className) },
            React.createElement("div", { className: styles.header },
                React.createElement(IconButton_1.default, { className: styles.left, onClick: function () {
                        _this.setState(getVariationDate(year, month, -1));
                    } },
                    React.createElement(md_1.MdKeyboardArrowLeft, null)),
                React.createElement("div", { className: styles.selects },
                    React.createElement(NativeSelect_1.default, { className: styles.select, options: exports.years, value: year, onChange: function (value) {
                            _this.setState({ year: value });
                        } }),
                    React.createElement(NativeSelect_1.default, { className: styles.select, options: exports.months, value: month, onChange: function (value) {
                            _this.setState({ month: value });
                        } })),
                React.createElement(IconButton_1.default, { className: styles.right, onClick: function () {
                        _this.setState(getVariationDate(year, month, 1));
                    } },
                    React.createElement(md_1.MdKeyboardArrowRight, null))),
            React.createElement("div", { className: styles.captions }, exports.captions.map(function (caption) {
                return (React.createElement("div", { className: styles.caption, key: caption }, caption));
            })),
            React.createElement("div", { className: styles.days }, days)));
    };
    return DatePicker;
}(React.Component));
exports.default = DatePicker;
